import { Text } from "@fscrypto/flip-kit/text";
import { Check } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "../../components/dialog/dialog";
import { type Props as ContactFormProps, ContactUsForm, type FormData } from "./contact-us-form";

export const ContactUsDialog = ({
  children,
  tracking,
  open,
  setOpen,
  messagePrompt,
  defaultValues,
}: {
  messagePrompt: string;
  children?: React.ReactNode;
  tracking?: (event: string, interfaceMsg?: string, properties?: Record<string, string | null>) => void;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  defaultValues?: ContactFormProps["defaultValues"];
}) => {
  const onSubmit = async (data: FormData) => {
    tracking?.("contact_form_submit", undefined, {
      name: data.name ?? null,
      email: data.email ?? null,
      telegram: data.telegram ?? null,
    });

    // marketing site endpoint
    const response = await fetch("/home/api/contact", {
      method: "post",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="w-full bg-bg-secondary p-8 dark" showClose>
        <div className="space-y-6">
          <Text variant="body-lg">Contact Us</Text>
          <Text className="block text-text-secondary">
            Whether you're launching a protocol, scaling a product, or leading chain growth, our team can help you
            activate the users that matter most.
          </Text>
          <Text className="block text-text-secondary">
            Looking to access the Flipside Growth MCP?{" "}
            <a href="/chat/" className="underline">
              Register here
            </a>
          </Text>
          <div className="space-y-1 pb-6">
            <CheckListItem>Book a free session with a growth strategist</CheckListItem>
            <CheckListItem>Learn about Intelligence-Driven Growth</CheckListItem>
            <CheckListItem>Grow your ecosystem</CheckListItem>
          </div>
        </div>
        <ContactUsForm
          onSubmit={onSubmit}
          messagePrompt={messagePrompt}
          buttonText="SEND MESSAGE"
          defaultValues={{
            memberStatus: "Submitted",
            campaignId: "f35b55a3-6eb4-4e26-9f8f-746f26ba837b",
            ...defaultValues,
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export const CheckListItem = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center gap-2">
      <Check className="w-4 h-4 text-brand-3" />
      <span className="text-text-secondary">{children}</span>
    </div>
  );
};
